export default __webpack_public_path__ + "static/media/ic-test-1.b403cdad.svg";